import { FunctionComponent, ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import "./KpiCard.scss";

export type KpiVariant = "success" | "danger" | "warn" | "info" | "neutral";

interface KpiCardProps {
    icon: LucideIcon;
    label: ReactNode;
    value: ReactNode;
    variant?: KpiVariant;
    /** opcional, mostra abaixo do valor (ex: variacao 24h) */
    hint?: ReactNode;
    className?: string;
    onClick?: () => void;
}

/**
 * Card de KPI (label + valor grande mono + icone colorido).
 * Substitui o trecho repetido em home cliente e org home.
 */
const KpiCard: FunctionComponent<KpiCardProps> = ({
    icon: Icon,
    label,
    value,
    variant = "info",
    hint,
    className = "",
    onClick,
}) => {
    return (
        <div
            className={`page-card kpi-card variant-${variant} ${onClick ? "interactive" : ""} ${className}`.trim()}
            onClick={onClick}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            <div className="kpi-icon"><Icon size={18} /></div>
            <div className="kpi-info">
                <small>{label}</small>
                <strong className="num">{value}</strong>
                {hint && <span className="kpi-hint">{hint}</span>}
            </div>
        </div>
    );
};

export default KpiCard;
